import type { ApiResponse } from './types';
import routes from '@/config/routes';
import { v3Get, v3Post } from './axios.instance.V3';
import { ICourseClass } from '@/store/admin/types/types';
import { IClassesSummaryGetRequest } from '@/store/types';

const getFilters = (): ApiResponse => v3Get(`${routes.backendUrl.classBuilder.getFilters}`);

const getFiltersForGig = (gigId: number): ApiResponse =>
  v3Get(`${routes.backendUrl.classBuilder.getFiltersForGig.replace('{gigId}', gigId.toString())}`);

const getAllClasses = (payload: IClassesSummaryGetRequest): ApiResponse =>
  v3Post(`${routes.backendUrl.classBuilder.getAllClasses}`, payload);

const saveClass = (courseClass: ICourseClass): ApiResponse =>
  v3Post(`${routes.backendUrl.classBuilder.saveClass}`, courseClass);

const getClassAndSessionDetails = (clientId: number): ApiResponse =>
  v3Get(`${routes.backendUrl.classBuilder.getClassAndSessionDetails.replace('{classId}', clientId.toString())}`);

const getClassAttendanceDetails = (clientId: number): ApiResponse =>
  v3Get(`${routes.backendUrl.classBuilder.getClassAttendanceDetails.replace('{classId}', clientId.toString())}`);

const getClassTrainers = (classId: number): ApiResponse =>
  v3Get(`${routes.backendUrl.client.getClassTrainers.replace('{clientId}', classId.toString())}`);

const getClassUserCount = (classId: number): ApiResponse =>
  v3Get(`${routes.backendUrl.classBuilder.getClassUserCount.replace('{classId}', classId.toString())}`);

const deleteClass = (classId: number): ApiResponse =>
  v3Post(`${routes.backendUrl.classBuilder.deleteClass.replace('{classId}', classId.toString())}`, undefined);

const getClassCountryApplicantCount = (classId: number): ApiResponse =>
  v3Get(`${routes.backendUrl.classBuilder.getClassCountryApplicants.replace('{classId}', classId.toString())}`);

export const classApis = {
  getFilters,
  getFiltersForGig,
  getAllClasses,
  saveClass,
  getClassAndSessionDetails,
  getClassAttendanceDetails,
  getClassUserCount,
  deleteClass,
  getClassCountryApplicantCount,
  getClassTrainers,
};
